<template>
  <div class="desktop-wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DesktopWrapper'
}
</script>